import type { Button } from 'primereact/button';

/**
 * Moves focus to the `<button>` a PrimeReact `Button` ref points at.
 *
 * PrimeReact types the ref as a class component, but `Button` forwards it to
 * the rendered `<button>` itself (`ObjectUtils.combinedRefs(elementRef, ref)`),
 * so the handle is a plain `HTMLButtonElement` at runtime. The cast lives here
 * so callers do not each repeat it. A `null` ref (unmounted) is a no-op.
 */
export function focusPrimeButton(ref: Button | null | undefined): void {
  const element = ref as unknown as HTMLElement | null | undefined;
  if (element && typeof element.focus === 'function') element.focus();
}
